import { render, staticRenderFns } from "./cuttingOptimiserStationView.vue?vue&type=template&id=1c8908c0&scoped=true&"
import script from "./cuttingOptimiserStationView.vue?vue&type=script&lang=js&"
export * from "./cuttingOptimiserStationView.vue?vue&type=script&lang=js&"
import style0 from "./cuttingOptimiserStationView.vue?vue&type=style&index=0&id=1c8908c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8908c0",
  null
  
)

export default component.exports